import { useReleaseFlag } from 'hooks/useReleaseFlags';

export const useAQIStationsLayerEnabled = (): boolean => {
  return useReleaseFlag('aqi_stations_layer');
};
